module.exports = __webpack_public_path__ + "assets/icon_settings.svg?v=1ce9255a5ca5ddd5f3b19e61d3053892";